import React from 'react'

import './BaseButton.scss'

interface BaseButtonProps {
    disabled?: boolean
    onClick?: () => void,
    className?: string
    text: string
    type?: string
}

const BaseButton: React.FC<BaseButtonProps> = ({disabled, onClick, className, text, type = "filled" }: BaseButtonProps) => {
    const onBtnClick = () => {
        !disabled && onClick && onClick()
    }
    return <button className={`basebutton ${type} ${className || ''} ${disabled && 'basebuttonDisabled'}`} onClick={onBtnClick}>{text}</button>
}

export default BaseButton;
